import axios from "axios";
import { BACKEND_API_URL } from "../config";

const api = axios.create({
    baseURL: `${BACKEND_API_URL}/api/`,
});

api.interceptors.request.use(
    (config) => {
        const accessToken = sessionStorage.getItem("access_token");

        if (accessToken) {
            config.headers.Authorization = `Bearer ${accessToken}`;
        }

        return config;
    }
);

api.interceptors.response.use(
    (response) => { return response },

    async (error) => {
        const originalRequest = error.config;

        if (
            error.response?.status === 401 &&
            !originalRequest._retry
        ) {

            originalRequest._retry = true;

            const refreshToken = sessionStorage.getItem("refresh_token");

            if (refreshToken) {
                try {
                    const res = await axios.post(`${BACKEND_API_URL}/api/refresh`, {
                        refresh: refreshToken,
                    });

                    const newAccess = res.data.access;

                    sessionStorage.setItem("access_token", newAccess);
                    originalRequest.headers.Authorization = `Bearer ${newAccess}`;

                    return api(originalRequest);
                } catch (refreshError) {
                    sessionStorage.removeItem("access_token");
                    sessionStorage.removeItem("refresh_token");
                    window.location.href = "/";
                    return Promise.reject(refreshError);
                }
            }
        }

        return Promise.reject(error);
    }
);


export default api;